import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'
import Company from '@/types/company'

export const getCompanies = async (
  userId: number,
  options?: AxiosRequestConfig,
) => {
  const { data } = await usersApi.get<Company[]>(apiRoutes.getCompanies, {
    ...options,
    params: {
      user: userId,
    },
  })

  return data
}
